import { render, staticRenderFns } from "./If65TagSelector.vue?vue&type=template&id=f24ebf86"
import script from "./If65TagSelector.vue?vue&type=script&lang=js"
export * from "./If65TagSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports